var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gj-image',{attrs:{"src":_vm.row.imageUrl,"tag-color":"rgb(246 144 10)","tag":_vm.groupType === 'variationAsin' && !_vm.row.nonVariationAsin ? '变' : null}})}
var staticRenderFns = []

export { render, staticRenderFns }